/** Current remaining time plus each intervening playable level. */
export function nextBreakSeconds(
  levels: { levelNo: number; isBreak: boolean; durationSecs?: number | null }[],
  currentLevel: number,
  remaining: number,
  levelSecs: number,
  enabled = true,
): number | null {
  if (!enabled || levels.find((level) => level.levelNo === currentLevel)?.isBreak) return null;
  const next = levels.find((level) => level.levelNo > currentLevel && level.isBreak);
  if (!next) return null;
  return (
    Math.max(0, remaining) +
    levels.reduce(
      (total, level) =>
        total +
        (level.levelNo > currentLevel && level.levelNo < next.levelNo
          ? (level.durationSecs ?? levelSecs)
          : 0),
      0,
    )
  );
}
